module.exports = __webpack_public_path__ + "static/img/youngIcon3.11e79060.png";